import { Component, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1304Model } from './kymw1304.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CheckPCodeService } from './api-services/check-pcode.service';
import { KYMW1304OutputModel } from './vo/kymw1304-output.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';

/**
 * Ｐコード一発選定画面を管理するクラス
 *
 * @export KYMW1304Component
 * @class KYMW1304Component
 */
@Component({
  selector: 'app-kymw1304',
  templateUrl: 'kymw1304.component.html',
  styleUrls: ['kymw1304.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1304Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw1304Model: KYMW1304Model = new KYMW1304Model();

  setKYMW1304Parameter: Function;

  /**
   *Creates an instance of KYMW1304Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1304Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private checkPCodeService: CheckPCodeService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1304Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1304';
  }

  /**
   * Ｐコード変更イベント処理
   */
  public txtiPCodeChanged(): void {
    // Ｐコード正規表現チェック
    if (PlessViewUtilsSub.validatePCode(this.kymw1304Model.pCode)) {            // 適切な場合
      this.kymw1304Model.enabled = true;
    } else {                                                                    // 不適切な場合
      this.kymw1304Model.enabled = false;
    }
  }

  /**
   * 「選定」ボタン押下イベント処理
   */
  public btnSelectClicked(): void {
    const checkPcodeVO = {
      pCode: this.kymw1304Model.pCode,
    };

    // ＰコードチェックAPI呼び出し
    this.checkPCodeService.execute(this.kymw1304Model, checkPcodeVO,
      (data: any) => this.checkPCodeServiceSuccessFunc(data),
      (status: string, result: any) => this.checkPCodeServiceExceptionErrorFunc(status, result));
  }

  /**
   * ＰコードチェックAPI成功処理
   *
   * @private
   * @param {*} data APIレスポンス
   * @memberof KYMW1304Component
   */
  private checkPCodeServiceSuccessFunc(data: any): void {
    // 承認区分のチェック
    if (data.AdmitStatus === '0') {                                          // 「0：eBASE取込後」の場合
      const array: Array<string> = new Array<string>();
      array.push('承認状態がeBASE取込後');
      array.push('選定');
      this.dialogService.openAlertGetMessage('E0164', array, () => { });
    } else if (data.AdmitStatus === '1') {                                   // 「1：仮登録」の場合
      const array: Array<string> = new Array<string>();
      array.push('承認状態が仮登録');
      array.push('選定');
      this.dialogService.openAlertGetMessage('E0164', array, () => { });
    } else {                                                                    // 上記以外の場合
      const kymw1304OutputVO: KYMW1304OutputModel = new KYMW1304OutputModel();
      kymw1304OutputVO.pcode = this.kymw1304Model.pCode;

      // 呼び出し元画面に値を返す
      this.setKYMW1304Parameter(kymw1304OutputVO);
    }

    this.kymw1304Model.pCode = '';
    this.kymw1304Model.enabled = false;
  }

  /**
   * ＰコードチェックAPI例外エラー処理
   *
   * @private
   * @param {*} data APIレスポンス
   * @memberof KYMW1304Component
   */
  private checkPCodeServiceExceptionErrorFunc(status: string, result: any): void {
    if (status === 'noresult') {
      this.dialogService.openAlertGetMessage('E0100', null, () => { });
      this.kymw1304Model.pCode = '';
      this.kymw1304Model.enabled = false;
    } else {
      this.dialogService.openAlertGetMessage('E0100', null, () => { });
      this.kymw1304Model.pCode = '';
      this.kymw1304Model.enabled = false;
    }
  }
}
